import { createRegExpFromString } from "@jti/fe-common";
import type { OrderAttribute } from "@jti/magento";
import type { RegisterOptions, Translate } from "@jti/ui";

import { coerceAttributeBoolean } from "../coerceAttributeBoolean";

export const textInputOrderAttributesValidationRulesFactory = (attribute: OrderAttribute, t: Translate) => {
  const rules: RegisterOptions = {};
  if (attribute.is_required) {
    rules.required = { value: true, message: t("form_validation.field_required") };
  }
  if (attribute.min_length) {
    rules.minLength = { value: attribute.min_length, message: t("form_validation.min_length", [attribute.min_length]) };
  }
  if (attribute.max_length) {
    rules.maxLength = { value: attribute.max_length, message: t("form_validation.max_length", [attribute.max_length]) };
  }

  const regex = createRegExpFromString(attribute.validate_regex);

  if (regex) {
    rules.pattern = { value: regex, message: t("form_validation.validate_regex") };
  } else if (attribute.numeric) {
    rules.valueAsNumber = true;
  }
  return rules;
};

export const checkboxInputOrderAttributesValidationRulesFactory = (attribute: OrderAttribute, t: Translate) => {
  const rules: RegisterOptions = {};
  if (attribute.is_required) {
    rules.validate = (val: unknown) => {
      if (!coerceAttributeBoolean(val)) {
        return t("form_validation.field_required");
      }
      return true;
    };
  }
  return rules;
};
